var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "checkout-section" },
    [
      _c(
        "div",
        {
          staticClass:
            "checkout-section__header checkout-section__header--no-line",
        },
        [
          _c("h2", { staticClass: "checkout-section__title" }, [
            _vm._v(_vm._s(_vm.data.passengerDetails.title)),
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "checkout-section__description",
            domProps: {
              innerHTML: _vm._s(_vm.data.passengerDetails.descriptionHtml),
            },
          }),
        ]
      ),
      _vm._v(" "),
      _vm.isLoginBoxDisplayed
        ? _c("Login")
        : _vm._l(_vm.passengers, function (passenger, index) {
            return _c("Passenger", {
              key: passenger.passengerId,
              attrs: { passenger: passenger, index: index },
            })
          }),
      _vm._v(" "),
      _c("PriceBreakdown", { attrs: { usePassengerDetails: true } }),
      _vm._v(" "),
      _c("Payment", { attrs: { brandName: _vm.data.brandNameFormatted } }),
      _vm._v(" "),
      _vm.hasDuplicateName
        ? _c("div", { staticClass: "error-message passenger__name-error" }, [
            _c("div", { staticClass: "error-message__icon" }),
            _vm._v(" "),
            _vm._m(0),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "checkout-section__footer" },
        [
          _c("NavButton", {
            class: {
              "btn btn--outline-gray-color btn--outline-gray-color_sm js-modal resultCardMapTs":
                _vm.data.brandNameFormatted === _vm.Brand.Travelsphere,
            },
            attrs: {
              back: true,
              text: "Back",
              stepBackAmount:
                _vm.excursionsVisited && !_vm.excursionsExist ? 2 : 1,
            },
          }),
          _vm._v(" "),
          _c("NavButton", {
            attrs: { text: "Continue to book", disabled: !_vm.canBook },
            on: { beforeNextStep: _vm.book },
          }),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "error-message__text" }, [
      _c("p", [
        _vm._v("You cannot continue with two passengers of the same name"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }